import { ConstellationScreenSize } from '@zg-rentals/rental-manager-env-base';
import React from 'react';
import { RentalManagerEnvironmentContext } from '../components/RentalManagerEnvironmentProvider';

export const useIsScreenDesktop = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);
  return environment.isScreenDesktop;
};

export const useIsScreenLG_GTE = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);

  return (
    environment.constellationScreenSize === ConstellationScreenSize.LG ||
    environment.constellationScreenSize === ConstellationScreenSize.XL ||
    environment.constellationScreenSize === ConstellationScreenSize.XXL
  );
};

export const useIsScreenXL_GTE = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);

  return (
    environment.constellationScreenSize === ConstellationScreenSize.XL ||
    environment.constellationScreenSize === ConstellationScreenSize.XXL
  );
};

export const useIsScreenMD_GTE = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);

  return React.useMemo(() => {
    return (
      environment.constellationScreenSize === ConstellationScreenSize.XL ||
      environment.constellationScreenSize === ConstellationScreenSize.XXL ||
      environment.constellationScreenSize === ConstellationScreenSize.LG ||
      environment.constellationScreenSize === ConstellationScreenSize.MD
    );
  }, [environment.constellationScreenSize]);
};

export const useIsScreenSM_GTE = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);

  return React.useMemo(() => {
    return (
      environment.constellationScreenSize === ConstellationScreenSize.XL ||
      environment.constellationScreenSize === ConstellationScreenSize.XXL ||
      environment.constellationScreenSize === ConstellationScreenSize.LG ||
      environment.constellationScreenSize === ConstellationScreenSize.MD ||
      environment.constellationScreenSize === ConstellationScreenSize.SM
    );
  }, [environment.constellationScreenSize]);
};

export const useIsScreenXXL = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);

  return environment.constellationScreenSize === ConstellationScreenSize.XXL;
};

export const useIsScreenXS = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);

  return environment.constellationScreenSize === ConstellationScreenSize.XS;
};
